// @flow
import React from 'react';
import path from 'ramda/es/path';
import prop from 'ramda/es/prop';
import { useTranslation } from 'react-i18next';

import type { TariffType, Sub } from 'app/components/Tariff/Tariff';
import Periods from 'app/components/Tariff/Periods';
import AvailableInformers from 'app/components/Tariff/AvailableInformers';

import Options from './Options';
import styles from './InformsPacks.scss';


/**
 * Информеры для пакетного тарифа
 */

type Props = {
  subId?: number,
  sub: Sub,
  tariff: TariffType,
  footnotes: Object,
  studentId: number,
}

const InformsPacks = ({
  subId,
  sub,
  tariff,
  footnotes,
  studentId,
}: Props) => {
  const { t } = useTranslation('tariff');
  const { inside = [] } = tariff;

  return (
    <div>
      <div className={styles.row}>
        <div className={styles.col}>
          <div>{`${t('informs_title')}:`}</div>
          <AvailableInformers
            tariff={inside[0]}
            footnotes={footnotes}
          />
        </div>
        <div className={styles.col}>
          <Periods
            header={`${t('available_subscriptions')}:`}
            subId={subId}
            // закомментирован старый вариант, теперь эти данные приходят для всего bundle
            // periods={path([0, 'month_daily_params', 'periods'], inside)}
            periods={path(['month_daily_params', 'periods'], tariff)
              || path([0, 'month_daily_params', 'periods'], inside)
              || []}
            paid={!!prop('prepaid_stop_at', sub)}
            isSms={false}
            studentId={studentId}
            tariffBundleId={tariff.id}
          />
        </div>
      </div>
      <Options
        studentId={studentId}
        inside={inside}
        subId={subId}
        locked={!sub}
        footnotes={footnotes}
      />
    </div>
  );
};

export default InformsPacks;
